import styled from 'styled-components';
import CardWithTitle from 'components/CardWithTitle';
import deviceSize from 'constants/deviceSize';

export const SCardWithTitleResponsive = styled(CardWithTitle)`
    width: 71rem;

    @media (max-width: ${deviceSize.mobile}px) {
        width: 100%;
    }
`;
